<template>
  <DatePicker
    @onChange="handleChange"
    :showValidationErrors="showValidationErrors"
    required
    :inputValue="answer"
  />
</template>

<script>
import DatePicker from "@/components/common/DatePicker";
import { first } from "lodash";

export default {
  props: {
    question: {
      type: Object,
      required: true
    },
    showValidationErrors: Boolean
  },
  components: {
    DatePicker
  },
  created() {
    if (this.question.answerData) {
      this.answer = first(this.question.answerData.answers);
    }
  },
  data() {
    return {
      answer: null
    };
  },
  methods: {
    handleChange(value) {
      this.answer = value;
      this.$emit("onChange", {
        answers: [value],
        question: {
          type: "booking-application-questions",
          id: this.question.id
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
